import axios from 'axios';
import React, { useEffect, useState } from 'react';

const ReportHeader = () => {
    const [headerImage, setHeaderImage] = useState('');
    const [userType, setUserType] = useState('');

    const downloadDocumentFunction = (fileName, type) => {
        axios
            .post(
                `/v1/utils/file/download`,
                { fileName },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then((result) => {
                if (type === 'header') {
                    setHeaderImage(result.data.data);
                }
            });
    };

    const getInstituteHeader = () => {
        axios
            .get(`/v1/institutes/get`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                    'Content-Type': 'application/json'
                }
            })
            .then((result) => {
                const data = result?.data?.data;
                if (!data) return;

                console.log(data?.externalClientHeader, 'data>>>>>>>');
                const fileName =
                    localStorage.getItem('userTypes') === 'EXTERNAL_CLIENT' ? data.externalClientHeader : data.hallTicketHeader;

                if (fileName) {
                    console.log('coming>>>>>>>');
                    downloadDocumentFunction(fileName, 'header');
                }
            });
    };

    useEffect(() => {
        const storedUserType = window.localStorage.getItem('userTypes') || '';
        setUserType(storedUserType);
    }, []);

    useEffect(() => {
        // if (userType) {
        getInstituteHeader();
        // }
    }, []);

    return (
        <>
            {headerImage && (
                <img
                    src={headerImage}
                    alt="Header"
                    style={{
                        maxWidth: '100%',
                        height: '80px',
                        display: 'block',
                        objectFit: 'contain'
                    }}
                />
            )}
        </>
    );
};

export default ReportHeader;
